let audioContext: AudioContext | null = null;
let unlockBound = false;

function context(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AudioCtx = window.AudioContext ?? window.webkitAudioContext;
  if (!AudioCtx) return null;
  audioContext ??= new AudioCtx();
  return audioContext;
}

function unlock(): void {
  const ctx = context();
  if (ctx?.state === "suspended") {
    void ctx.resume();
  }
}

function bindUnlock(): void {
  if (unlockBound || typeof window === "undefined") return;
  unlockBound = true;
  window.addEventListener("pointerdown", unlock);
  window.addEventListener("keydown", unlock);
}

function tone(
  ctx: AudioContext,
  frequency: number,
  startAt: number,
  duration: number,
): void {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = "sine";
  oscillator.frequency.setValueAtTime(frequency, startAt);
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(0.08, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startAt);
  oscillator.stop(startAt + duration + 0.02);
}

/** Short two-note chime. Browsers stay silent until the user has clicked or typed once. */
export function playNotificationSound(): void {
  bindUnlock();
  const ctx = context();
  if (!ctx) return;
  if (ctx.state === "suspended") {
    void ctx.resume().then(() => {
      if (ctx.state === "running") playNotificationSound();
    });
    return;
  }
  const start = ctx.currentTime;
  tone(ctx, 880, start, 0.12);
  tone(ctx, 1174, start + 0.13, 0.16);
}
